import { default as _91_46_46_46cms_93vIwFE3N0dEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93xODwk1rdX2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexI60Tn5lfZVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93O2u4C6jVROMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/akcii/[...slug].vue?macro=true";
import { default as indexxb7KmdKC9JMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93nAXoU8ng6oMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/articles/[...slug].vue?macro=true";
import { default as indexAX65ni1KGlMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/articles/index.vue?macro=true";
import { default as indexdrbZs0HJKCMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/authorization/index.vue?macro=true";
import { default as indexKuJtdKtWHAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_936kwU02q0MIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93FtTIaNmk4yMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalog/[...slug].vue?macro=true";
import { default as indexevPAmOeppXMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93JISV1GaP4mMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultnXXnWF2yzpMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalogsearch/result.vue?macro=true";
import { default as indexqYIlhEmyKlMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93Uwqb5MZhwRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_930cNgKBi7etMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/fabriki/[...slug].vue?macro=true";
import { default as indexgtI803viMgMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/fabriki/index.vue?macro=true";
import { default as _91_46_46_46slug_93hVI38YY8PjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/product/[...slug].vue?macro=true";
import { default as indexPgwUMrRTPsMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/profile/index.vue?macro=true";
import { default as index1vKDVjO8MiMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/profile/orders/index.vue?macro=true";
import { default as indexqXUc4X37rHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93pCRRO9l8iIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/sets/[...slug].vue?macro=true";
import { default as index3lghbVl2BWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93vIwFE3N0dEMeta?.name ?? "cms",
    path: _91_46_46_46cms_93vIwFE3N0dEMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93vIwFE3N0dEMeta || {},
    alias: _91_46_46_46cms_93vIwFE3N0dEMeta?.alias || [],
    redirect: _91_46_46_46cms_93vIwFE3N0dEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93xODwk1rdX2Meta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93xODwk1rdX2Meta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93xODwk1rdX2Meta || {},
    alias: _91_46_46_46slug_93xODwk1rdX2Meta?.alias || [],
    redirect: _91_46_46_46slug_93xODwk1rdX2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexI60Tn5lfZVMeta?.name ?? "3d-projects",
    path: indexI60Tn5lfZVMeta?.path ?? "/3d-projects",
    meta: indexI60Tn5lfZVMeta || {},
    alias: indexI60Tn5lfZVMeta?.alias || [],
    redirect: indexI60Tn5lfZVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93O2u4C6jVROMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93O2u4C6jVROMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93O2u4C6jVROMeta || {},
    alias: _91_46_46_46slug_93O2u4C6jVROMeta?.alias || [],
    redirect: _91_46_46_46slug_93O2u4C6jVROMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexxb7KmdKC9JMeta?.name ?? "akcii",
    path: indexxb7KmdKC9JMeta?.path ?? "/akcii",
    meta: indexxb7KmdKC9JMeta || {},
    alias: indexxb7KmdKC9JMeta?.alias || [],
    redirect: indexxb7KmdKC9JMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93nAXoU8ng6oMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93nAXoU8ng6oMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93nAXoU8ng6oMeta || {},
    alias: _91_46_46_46slug_93nAXoU8ng6oMeta?.alias || [],
    redirect: _91_46_46_46slug_93nAXoU8ng6oMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexAX65ni1KGlMeta?.name ?? "articles",
    path: indexAX65ni1KGlMeta?.path ?? "/articles",
    meta: indexAX65ni1KGlMeta || {},
    alias: indexAX65ni1KGlMeta?.alias || [],
    redirect: indexAX65ni1KGlMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexdrbZs0HJKCMeta?.name ?? "authorization",
    path: indexdrbZs0HJKCMeta?.path ?? "/authorization",
    meta: indexdrbZs0HJKCMeta || {},
    alias: indexdrbZs0HJKCMeta?.alias || [],
    redirect: indexdrbZs0HJKCMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexKuJtdKtWHAMeta?.name ?? "cart",
    path: indexKuJtdKtWHAMeta?.path ?? "/cart",
    meta: indexKuJtdKtWHAMeta || {},
    alias: indexKuJtdKtWHAMeta?.alias || [],
    redirect: indexKuJtdKtWHAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_936kwU02q0MIMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_936kwU02q0MIMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_936kwU02q0MIMeta || {},
    alias: _91_46_46_46id_936kwU02q0MIMeta?.alias || [],
    redirect: _91_46_46_46id_936kwU02q0MIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93FtTIaNmk4yMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93FtTIaNmk4yMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93FtTIaNmk4yMeta || {},
    alias: _91_46_46_46slug_93FtTIaNmk4yMeta?.alias || [],
    redirect: _91_46_46_46slug_93FtTIaNmk4yMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexevPAmOeppXMeta?.name ?? "catalog",
    path: indexevPAmOeppXMeta?.path ?? "/catalog",
    meta: indexevPAmOeppXMeta || {},
    alias: indexevPAmOeppXMeta?.alias || [],
    redirect: indexevPAmOeppXMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93JISV1GaP4mMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93JISV1GaP4mMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93JISV1GaP4mMeta || {},
    alias: _91_46_46_46slug_93JISV1GaP4mMeta?.alias || [],
    redirect: _91_46_46_46slug_93JISV1GaP4mMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultnXXnWF2yzpMeta?.name ?? "catalogsearch-result",
    path: resultnXXnWF2yzpMeta?.path ?? "/catalogsearch/result",
    meta: resultnXXnWF2yzpMeta || {},
    alias: resultnXXnWF2yzpMeta?.alias || [],
    redirect: resultnXXnWF2yzpMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexqYIlhEmyKlMeta?.name ?? "clear-page-slider",
    path: indexqYIlhEmyKlMeta?.path ?? "/clear-page-slider",
    meta: indexqYIlhEmyKlMeta || {},
    alias: indexqYIlhEmyKlMeta?.alias || [],
    redirect: indexqYIlhEmyKlMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Uwqb5MZhwRMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93Uwqb5MZhwRMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93Uwqb5MZhwRMeta || {},
    alias: _91_46_46_46slug_93Uwqb5MZhwRMeta?.alias || [],
    redirect: _91_46_46_46slug_93Uwqb5MZhwRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930cNgKBi7etMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_930cNgKBi7etMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_930cNgKBi7etMeta || {},
    alias: _91_46_46_46slug_930cNgKBi7etMeta?.alias || [],
    redirect: _91_46_46_46slug_930cNgKBi7etMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexgtI803viMgMeta?.name ?? "fabriki",
    path: indexgtI803viMgMeta?.path ?? "/fabriki",
    meta: indexgtI803viMgMeta || {},
    alias: indexgtI803viMgMeta?.alias || [],
    redirect: indexgtI803viMgMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93hVI38YY8PjMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93hVI38YY8PjMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93hVI38YY8PjMeta || {},
    alias: _91_46_46_46slug_93hVI38YY8PjMeta?.alias || [],
    redirect: _91_46_46_46slug_93hVI38YY8PjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexPgwUMrRTPsMeta?.name ?? "profile",
    path: indexPgwUMrRTPsMeta?.path ?? "/profile",
    meta: indexPgwUMrRTPsMeta || {},
    alias: indexPgwUMrRTPsMeta?.alias || [],
    redirect: indexPgwUMrRTPsMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: index1vKDVjO8MiMeta?.name ?? "profile-orders",
    path: index1vKDVjO8MiMeta?.path ?? "/profile/orders",
    meta: index1vKDVjO8MiMeta || {},
    alias: index1vKDVjO8MiMeta?.alias || [],
    redirect: index1vKDVjO8MiMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexqXUc4X37rHMeta?.name ?? "recently",
    path: indexqXUc4X37rHMeta?.path ?? "/recently",
    meta: indexqXUc4X37rHMeta || {},
    alias: indexqXUc4X37rHMeta?.alias || [],
    redirect: indexqXUc4X37rHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93pCRRO9l8iIMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93pCRRO9l8iIMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93pCRRO9l8iIMeta || {},
    alias: _91_46_46_46slug_93pCRRO9l8iIMeta?.alias || [],
    redirect: _91_46_46_46slug_93pCRRO9l8iIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index3lghbVl2BWMeta?.name ?? "wishlist",
    path: index3lghbVl2BWMeta?.path ?? "/wishlist",
    meta: index3lghbVl2BWMeta || {},
    alias: index3lghbVl2BWMeta?.alias || [],
    redirect: index3lghbVl2BWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/pages/wishlist/index.vue").then(m => m.default || m)
  }
]